import * as React from "react";
import { cn } from "../../lib/utils";

export interface EDSListItemProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  selected?: boolean;
  disabled?: boolean;
}

const EDSListItem = React.forwardRef<HTMLButtonElement, EDSListItemProps>(
  ({ children, className, onClick, selected, disabled, ...props }, ref) => {
    return (
      <button
        type="button"
        ref={ref}
        className={cn(
          "eds-list-item",
          "w-full text-left",
          "px-3 py-2",
          "cursor-pointer",
          "transition-colors",
          "hover:bg-accent hover:text-accent-foreground",
          "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
          "first:rounded-t-md last:rounded-b-md",
          "border-b border-border last:border-b-0",
          "bg-transparent border-0",
          selected && "bg-accent text-accent-foreground",
          disabled && "opacity-50 cursor-not-allowed",
          className
        )}
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
        {...props}
      >
        {children}
      </button>
    );
  }
);

EDSListItem.displayName = "EDSListItem";

export { EDSListItem };
